import { type PageContext, PageContextContext } from './PageContextContext.js';
import { type ReactNode } from 'react';

export const PageContextProvider = ({
  children,
  pageContext,
}: {
  readonly children: ReactNode;
  readonly pageContext: PageContext;
}) => {
  return (
    <PageContextContext.Provider value={pageContext}>
      {children}
    </PageContextContext.Provider>
  );
};
